import { useEffect } from 'react'
import { Sparkles } from 'lucide-react'
import styled from 'styled-components'
import BasePage from '../basePage'
import { AgendaInteligenteController } from '../../services/controllers/agendaInteligente'
import { useAgendaInteligente } from '../../store/agendaInteligente/useAgendaInteligente'
import { DAY_TABS } from './constants'
import { AgendaInteligenteFilter } from './AgendaInteligenteFilter'
import { AgendaInteligenteSummary } from './AgendaInteligenteSummary'
import { AgendaInteligenteTable } from './AgendaInteligenteTable'
import { SettingsModal } from './SettingsModal'
import { WhatsAppModal } from './WhatsAppModal'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-bottom: 40px;
  padding-right: 10px;
  width: 100%;
`

const TabsRow = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 2px solid ${p => p.theme.colors.gray[200]};
`

const TabBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: ${p => p.active ? 'bold' : 'normal'};
  color: ${p => p.active ? p.theme.colors.scale[700] : p.theme.colors.gray[500]};
  background: none;
  border: none;
  border-bottom: 3px solid ${p => p.active ? p.theme.colors.scale[500] : 'transparent'};
  margin-bottom: -2px;
  cursor: pointer;
  transition: all 0.15s;
  &:hover { color: ${p => p.theme.colors.scale[600]}; }
`

const TabCount = styled.span`
  background: ${p => p.active ? p.theme.colors.scale[500] : p.theme.colors.gray[200]};
  color: ${p => p.active ? '#fff' : p.theme.colors.gray[600]};
  border-radius: 20px;
  padding: 1px 8px;
  font-size: 11px;
  font-weight: bold;
`

const IconBtn = styled.button`
  display: grid; place-items: center;
  width: 30px; height: 30px;
  border-radius: 5px;
  border: 1px solid ${p => p.theme.colors.gray[200]};
  background: #fff;
  cursor: pointer;
  &:hover { border-color: ${p => p.theme.colors.scale[500]}; }
`

const ErrorBanner = styled.div`
  display: flex; align-items: center; gap: 10px;
  padding: 12px 16px;
  border-radius: 5px;
  border: 1px solid #fca5a5;
  background: #fef2f2;
  color: #991b1b;
  font-size: 13px;
`

const HelpText = styled.p`
  margin: 0;
  font-size: 11px;
  color: ${p => p.theme.colors.gray[400]};
`

export function AgendaInteligente() {
  const CAgendaInteligente = AgendaInteligenteController()
  const activeTab = useAgendaInteligente(st => st.data.activeTab)
  const resumo = useAgendaInteligente(st => st.data.resumo)
  const isLoading = useAgendaInteligente(st => st.data.isLoading)
  const error = useAgendaInteligente(st => st.data.error)

  useEffect(() => { CAgendaInteligente.fetchData() }, [])

  return (
    <BasePage pageTitle={<span style={{ display: 'flex', alignItems: 'center', gap: 8 }}><Sparkles size={16} />Agendamentos</span>}>
      <Container>

        <TabsRow>
          {DAY_TABS.map(dayTab => (
            <TabBtn key={dayTab.key} active={activeTab === dayTab.key} onClick={() => CAgendaInteligente.setActiveTab(dayTab.key)}>
              {dayTab.label}
              <TabCount active={activeTab === dayTab.key}>
                {resumo?.[dayTab.key]?.total ?? 0}
              </TabCount>
            </TabBtn>
          ))}
        </TabsRow>
        {error && (
          <ErrorBanner>
            {error}
            <button onClick={CAgendaInteligente.fetchData} style={{ marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline', color: '#991b1b', fontSize: 12 }}>
              Tentar novamente
            </button>
          </ErrorBanner>
        )}

        <AgendaInteligenteFilter />
        <AgendaInteligenteSummary />
        <AgendaInteligenteTable />

        <HelpText>
          Clique no horário para ver o histórico · Marque <strong>Feito</strong> após o contato e atualize o <strong>status</strong>.
        </HelpText>

      </Container>

      <SettingsModal />
      <WhatsAppModal />

      <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
    </BasePage>
  )
}

export default AgendaInteligente
